import { motion } from "framer-motion";
import { Check, Sparkles } from "lucide-react";

interface PricingCardProps {
  name: string;
  price: number;
  currency: string;
  period: string;
  description: string;
  features: string[];
  isPopular?: boolean;
  index: number;
}

export function PricingCard({
  name,
  price,
  currency,
  period,
  description,
  features,
  isPopular,
  index,
}: PricingCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.1 * index }}
      className={`relative card-elevated p-8 ${
        isPopular ? "border-2 border-primary ring-4 ring-primary/10" : ""
      }`}
    >
      {isPopular && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2">
          <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-primary text-primary-foreground text-sm font-medium shadow-emerald">
            <Sparkles className="w-4 h-4" />
            Cel mai popular
          </div>
        </div>
      )}

      <div className="text-center mb-8">
        <h3 className="text-xl font-semibold text-foreground mb-2">{name}</h3>
        <p className="text-muted-foreground text-sm mb-4">{description}</p>
        <div className="flex items-baseline justify-center gap-1">
          <span className="text-4xl font-bold text-foreground">{price}</span>
          <span className="text-muted-foreground">{currency}</span>
          <span className="text-muted-foreground">/{period}</span>
        </div>
      </div>

      <ul className="space-y-3 mb-8">
        {features.map((feature) => (
          <li key={feature} className="flex items-start gap-3">
            <div className="w-5 h-5 rounded-full bg-accent flex items-center justify-center flex-shrink-0 mt-0.5">
              <Check className="w-3 h-3 text-primary" />
            </div>
            <span className="text-sm text-foreground">{feature}</span>
          </li>
        ))}
      </ul>

      <p className="text-center text-sm text-muted-foreground pt-2">
        Contactează-ne la{" "}
        <a
          href="mailto:contactoptiro@gmail.com"
          className="text-primary hover:underline font-medium"
        >
          contactoptiro@gmail.com
        </a>
        {" "}pentru a te abona.
      </p>
    </motion.div>
  );
}
